import { render, staticRenderFns } from "./TransferRatio.container.vue?vue&type=template&id=0ab7a52f&scoped=true&"
import script from "./TransferRatio.container.vue?vue&type=script&lang=js&"
export * from "./TransferRatio.container.vue?vue&type=script&lang=js&"
import style0 from "./TransferRatio.container.vue?vue&type=style&index=0&id=0ab7a52f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7a52f",
  null
  
)

export default component.exports